var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / file"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10.0007C5.83333 9.54041 6.20643 9.16732 6.66667 9.16732H13.3333C13.7936 9.16732 14.1667 9.54041 14.1667 10.0007C14.1667 10.4609 13.7936 10.834 13.3333 10.834H6.66667C6.20643 10.834 5.83333 10.4609 5.83333 10.0007Z",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.334C6.20643 13.334 5.83333 13.7071 5.83333 14.1673C5.83333 14.6276 6.20643 15.0006 6.66667 15.0006H13.3333C13.7936 15.0006 14.1667 14.6276 14.1667 14.1673C14.1667 13.7071 13.7936 13.334 13.3333 13.334H6.66667Z",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 0.833984C3.99238 0.833984 2.5 2.32637 2.5 4.16732V15.834C2.5 17.6749 3.99238 19.1673 5.83333 19.1673H14.1667C16.0076 19.1673 17.5 17.6749 17.5 15.834V7.57244C17.5 6.79265 17.2266 6.03754 16.7274 5.43849L13.8898 2.03337C13.2565 1.27339 12.3183 0.833984 11.3291 0.833984H5.83333ZM4.16667 4.16732C4.16667 3.24684 4.91286 2.50065 5.83333 2.50065H10.8333V5.00065C10.8333 6.8416 12.3257 8.33398 14.1667 8.33398H15.8333V15.834C15.8333 16.7545 15.0871 17.5006 14.1667 17.5006H5.83333C4.91286 17.5006 4.16667 16.7545 4.16667 15.834V4.16732ZM15.5661 6.66732C15.5299 6.61127 15.4901 6.5572 15.447 6.50547L12.6094 3.10034C12.5747 3.0587 12.5382 3.01898 12.5 2.98127V5.00065C12.5 5.92112 13.2462 6.66732 14.1667 6.66732H15.5661Z",
    fill: "#667185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderInactive);
export default __webpack_public_path__ + "static/media/reminder-inactive.936acacbb590a46091232a80d1794a81.svg";
export { ForwardRef as ReactComponent };